import { SEARCH_FORM_KEY } from '@location/constants';

export const FIELD_KEY = {
  ALIAS: 'alias',
  STREET: SEARCH_FORM_KEY.STREET,
  DOOR_NUMBER: SEARCH_FORM_KEY.DOOR_NUMBER,
  COMPLEMENT: 'complement',
  CORNER: SEARCH_FORM_KEY.CORNER,
  CITY_NAME: SEARCH_FORM_KEY.CITY_NAME,
  AREA: 'area',
  NOTES: 'notes',
  PHONE: 'phone',

  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  VALIDATED: 'validated',
  ID: 'id',

  ADDRESS: SEARCH_FORM_KEY.ADDRESS,

  STREET_TYPE: SEARCH_FORM_KEY.STREET_TYPE,
};

export const NOTES_MAX_LENGTH = 300;
